var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Pricing.FlightInformationManagement"),
        width: "350px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "shipping-schedule-form-dialog details-view"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { width: "fit-content", "margin-left": "10px" } },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c("el-button", { on: { click: _vm.onCancel } }, [
              _vm._v(_vm._s(_vm.$t("Pricing.Cancel")))
            ])
          ],
          1
        ),
        _c("div", { staticStyle: { margin: "10px" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.FlightNo")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "flightNo" },
                          model: {
                            value: _vm.ss.flightNo,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "flightNo", $$v)
                            },
                            expression: "ss.flightNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.POL") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "default-value": _vm.ss.pol
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.ss.pol = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.POD") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            filterable: "",
                            "show-custom-label-in-option": true,
                            "default-value": _vm.ss.pod
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.ss.pod = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ClosingTime") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-time-picker", {
                              attrs: {
                                format: "HH:mm",
                                "value-format": "HH:mm",
                                clearable: ""
                              },
                              model: {
                                value: _vm.ss.closingTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.ss, "closingTime", $$v)
                                },
                                expression: "ss.closingTime"
                              }
                            }),
                            _c(
                              "el-tooltip",
                              {
                                staticStyle: {
                                  "align-items": "center",
                                  display: "flex",
                                  "margin-left": "5px"
                                },
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t("Pricing.emptyTime"),
                                  placement: "right-start"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: { "font-size": "20px" }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.DepartureTime") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-time-picker", {
                              attrs: {
                                format: "HH:mm",
                                "value-format": "HH:mm",
                                clearable: ""
                              },
                              model: {
                                value: _vm.ss.departureTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.ss, "departureTime", $$v)
                                },
                                expression: "ss.departureTime"
                              }
                            }),
                            _c(
                              "el-tooltip",
                              {
                                staticStyle: {
                                  "align-items": "center",
                                  display: "flex",
                                  "margin-left": "5px"
                                },
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t("Pricing.emptyTime"),
                                  placement: "right-start"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: { "font-size": "20px" }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ArrivalTime") } },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "110px" },
                                attrs: {
                                  placeholder: _vm.$t("Pricing.PlsSelect")
                                },
                                model: {
                                  value: _vm.ss.days,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ss, "days", $$v)
                                  },
                                  expression: "ss.days"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { value: 0, label: "+0" }
                                }),
                                _c("el-option", {
                                  attrs: { value: 1, label: "+1" }
                                }),
                                _c("el-option", {
                                  attrs: { value: 2, label: "+2" }
                                }),
                                _c("el-option", {
                                  attrs: { value: 3, label: "+3" }
                                })
                              ],
                              1
                            ),
                            _c("el-time-picker", {
                              attrs: {
                                format: "HH:mm",
                                "value-format": "HH:mm",
                                clearable: ""
                              },
                              model: {
                                value: _vm.ss.arrivalTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.ss, "arrivalTime", $$v)
                                },
                                expression: "ss.arrivalTime"
                              }
                            }),
                            _c(
                              "el-tooltip",
                              {
                                staticStyle: {
                                  "align-items": "center",
                                  display: "flex",
                                  "margin-left": "5px"
                                },
                                attrs: {
                                  effect: "dark",
                                  content: _vm.$t("Pricing.emptyTime"),
                                  placement: "right-start"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: { "font-size": "20px" }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Aircraft") } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ss.aircraft,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "aircraft", $$v)
                            },
                            expression: "ss.aircraft"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.SizeLimit") } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ss.sizeLimit,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "sizeLimit", $$v)
                            },
                            expression: "ss.sizeLimit"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Pricing.SingletonWeightLimit") }
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ss.singletonWeightLimit,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "singletonWeightLimit", $$v)
                            },
                            expression: "ss.singletonWeightLimit"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.ChemicalPkggReq") } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ss.chemicalPkggReq,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "chemicalPkggReq", $$v)
                            },
                            expression: "ss.chemicalPkggReq"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.LithiumBatteryReq") } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.ss.lithiumBatteryReq,
                            callback: function($$v) {
                              _vm.$set(_vm.ss, "lithiumBatteryReq", $$v)
                            },
                            expression: "ss.lithiumBatteryReq"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }